import { v4 as UUID } from 'uuid';

/**
 * Model to hold a tag for a team that can be applied to a calendar event
 */
export class IdentityTeamTag {
    public id: string = null;
    public isNew: boolean;
    public name: string = null;
    public teamId: string = null;

    constructor() {
        this.isNew = true;
        this.id = UUID();
    }

    public clone(): IdentityTeamTag {
        const clone: IdentityTeamTag = new IdentityTeamTag();
        clone.id = this.id;
        clone.name = this.name;
        clone.teamId = this.teamId;
        clone.isNew = this.isNew;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'teamTag';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: Object): IdentityTeamTag {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];

        this.id = data['id'];
        this.name = attrs['name'];
        this.teamId = attrs['teamId'];
        this.isNew = false;

        return this;
    }
}
